export class Page {
  hasNext: boolean;
  totalPages: number;
  currentPage: number;

  constructor(data: {
    hasNext: boolean;
    totalPages: number;
    currentPage: number;
  }) {
    this.hasNext = data.hasNext;
    this.totalPages = data.totalPages;
    this.currentPage = data.currentPage;
  }
}
